<template>
  <h1>Test1List</h1>
</template>

<script>
export default {
  name: "Test1List"
};
</script>

<style></style>
